import { Text } from '@chakra-ui/react';
import React from 'react';

const RequiredAsterisk = () => (
  <Text as="span" color="red.500" aria-hidden="true">
    {' *'}
  </Text>
);

/** Appends a red required-field asterisk to a label when needed. */
export function formatRequiredFieldLabel(label, isRequired) {
  if (!isRequired) {
    return label;
  }
  if (typeof label === 'string' && label.trim().endsWith('*')) {
    return (
      <>
        {label.trim().replace(/\s*\*$/, '')}
        <RequiredAsterisk />
      </>
    );
  }
  return (
    <>
      {label}
      <RequiredAsterisk />
    </>
  );
}
